<template>

    <div id="layout-legal" class="layout">
        <v-the-cookie-banner />
        <transition name="modal">
            <v-modal-cookie-preferences v-if="modal === 'cookie-preferences'" />
        </transition>
        <header class="legal-header">
            <router-link :to="{ name: 'home' }" class="logo">
                <img src="/img/mgr-logo.svg" :title="$brand" height="40" width="auto" />
            </router-link>
            <v-dropdown
                :items="policyItems"
                :label="$t('labels.policies')"
                :selected="currentPolicyKey"
                menu-position="br"
                @change="selectPolicy" />
        </header>
        <div class="container pb-30">
            <div class="row justify-content-center">
                <div class="legal-layout">
                    <div class="legal-sidebar-wrap">
                        <v-sidebar>
                            <router-link :to="{ name: 'home' }" class="sidebar-header">
                                <img src="/img/mgr-logo.svg" :title="$brand" height="40" width="auto" />
                            </router-link>
                            <v-sidebar-item
                                v-for="policy in policies"
                                :key="policy.key"
                                :active="currentPolicyKey === policy.key"
                                :icon="policy.icon"
                                :label="$t(policy.label)"
                                :to="{ name: policyRouteName(policy.key) }" />
                        </v-sidebar>
                    </div>
                    <div class="legal-main">
                        <div class="legal-content">
                            <transition name="fade" mode="out-in">
                                <router-view></router-view>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .legal-layout {
        display: flex;
        max-width: map-get($grid-breakpoints, 'xl');
        width: 100%;
    }

    .legal-main {
        display: flex;
        flex: 1;
        flex-direction: column;
        min-width: 0;
    }

    .legal-header {
        display: none;
    }

    .sidebar-header {
        align-items: center;
        border-bottom: 1px solid $color-rule;
        display: flex;
        flex-shrink: 0;
        justify-content: center;
        margin: -10px -10px 10px -10px;
        padding: 20px 10px;
        text-decoration: none;
    }

    .legal-content {
        flex: 1;
        min-width: 0;
        overflow-y: auto;
        padding: 30px;
    }

    #layout-legal .container {
        padding-top: 30px;
    }

    @media (max-width: map-get($grid-breakpoints, 'md')) {
        .legal-sidebar-wrap {
            display: none;
        }

        .legal-header {
            align-items: center;
            background: $color-white;
            box-shadow: 0 1px 2px rgba(0,0,0,0.2);
            display: flex;
            height: 60px;
            justify-content: space-between;
            left: 0;
            padding: 0 15px;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 2;
            .logo {
                align-items: center;
                text-decoration: none;
                transition: opacity .3s;
                &:hover {
                    opacity: 0.7;
                }
            }
        }

        #layout-legal .container {
            padding-top: 90px;
        }

        .legal-content {
            padding: 0;
        }
    }

</style>

<script>

import Sidebar from '@cmp/Sidebar';
import SidebarItem from '@cmp/SidebarItem';
import TheCookieBanner from '@cmp/TheCookieBanner';
import ModalCookiePreferences from '@modals/ModalCookiePreferences';

export default {

    components: {
        'v-modal-cookie-preferences': ModalCookiePreferences,
        'v-sidebar': Sidebar,
        'v-sidebar-item': SidebarItem,
        'v-the-cookie-banner': TheCookieBanner,
    },

    computed: {

        currentPolicyKey() {
            return (this.$route.name || '').slice('policies-'.length);
        },

        modal() {
            return this.$store.getters.modal;
        },

        policies() {
            return [
                { icon: 'fa-file-contract', key: 'terms', label: 'labels.terms_of_service' },
                { icon: 'fa-shield-check', key: 'privacy', label: 'labels.privacy_policy' },
                { icon: 'fa-cookie', key: 'cookies', label: 'labels.cookie_policy' },
                { icon: 'fa-file-signature', key: 'dpa', label: 'labels.dpa' },
                { icon: 'fa-server', key: 'sub-processors', label: 'labels.sub_processors' },
                { icon: 'fa-user-shield', key: 'dsar', label: 'labels.dsar' },
                { icon: 'fa-handshake', key: 'referral-program-terms', label: 'labels.referral_program' },
            ];
        },

        policyItems() {
            return this.policies.map((policy) => ({
                icon: `fas ${policy.icon}`,
                key: policy.key,
                value: this.$t(policy.label),
            }));
        },

    },

    methods: {

        policyRouteName(key) {
            return `policies-${key}`;
        },

        selectPolicy(item) {
            this.$router.push({ name: this.policyRouteName(item.key) });
        },

    },

}

</script>
